var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var contact = ref.contact;
    var isLoading = ref.isLoading;
    var isPreview = ref.isPreview;
    var errorMessage = ref.errorMessage;
return [_c('activation-brief-view',{attrs:{"brief":brief,"contact":contact,"is-preview":isPreview,"is-loading":isLoading,"error-message":errorMessage}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }